module.exports = __webpack_public_path__ + "img/bigBoxer@2x.bf15d9d4.png";